export default __webpack_public_path__ + "static/media/newsecret.fcd58c59.jpeg";